import React from "react";

const statusStyles = {
  closed: "bg-green-500",
  inprocess: "bg-primary",
  unsubmitted: "bg-orange-500",
  portal : "bg-[#0bafd430]",
  email: "bg-[#22c55c2e]"
};

const textStyle = {
  portal : "text-primary",
  email: "text-green-500"
}

const StatusBadge = ({ status }) => {
  const normalizedStatus = typeof status === "string" ? status.toLowerCase() : "";
  const bgColor = statusStyles[normalizedStatus] || "bg-gray-400";
  const textColor = textStyle[normalizedStatus] || "text-white";

  return (
    <span
      className={`px-2 py-1 rounded-full ${textColor} text-xs sub-title uppercase ${bgColor}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;